import type { CheckoutTicketBlueprint as GQLCheckoutTicketBlueprint } from '../generated/checkout.graphql';
import * as CheckoutBlueprintPriceBreakdown from './CheckoutBlueprintPriceBreakdown';
import { take } from '../util/takePayload';

export type CheckoutTicketBlueprint = {
  id: number;
  name: string;
  ticketType: 'ticket' | 'addon';
  description?: string;
  eventId: number;
  soldOut: boolean;
  category?: string;
  categoryId?: number;
  minimum?: number;
  maximum?: number;
  multiple?: number;
  breakdown?: CheckoutBlueprintPriceBreakdown.CheckoutBlueprintPriceBreakdown;
};

export const fromGql = (tb: GQLCheckoutTicketBlueprint): CheckoutTicketBlueprint => ({
  ...(take(
    tb,
    'id',
    'name',
    'ticketType',
    'description',
    'eventId',
    'soldOut',
    'category',
    'categoryId',
    'minimum',
    'maximum',
    'multiple',
  ) as CheckoutTicketBlueprint),
  breakdown: tb.breakdown ? CheckoutBlueprintPriceBreakdown.fromGql(tb.breakdown) : undefined,
});
